<template>
  <div class="border-top">
    <SOFilterTitle title="Sensor Pintu" :id="id"/>
    <div class="p-l-24 p-r-24 p-d-24" :id="id">
      <SOInputCheckbox :checked="filterItem.sensorPintu" :checkboxes="sensorPintu" @selected="selectedSensor"/>
    </div>
<!--    <template v-if="showStatus">-->
<!--      <SOFilterTitle title="Status Pintu" :id="'status-pintu'"/>-->
<!--      <div class="p-l-24 p-r-24 p-d-24" :id="'status-pintu'">-->
<!--        <SOInputCheckbox :checked="filterItem.statusPintu" :checkboxes="statusPintu" @selected="selectedStatus"/>-->
<!--      </div>-->
<!--    </template>-->
  </div>
</template>

<script>
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputCheckbox from "@/so-components/global/input/SOInputCheckbox";
import {mapGetters} from "vuex";

export default {
  name: "SOFilterStatusSensorPintu",
  components: {SOInputCheckbox, SOFilterTitle},
  props: {
    id: String
  },
  data() {
    return {
      showStatus: true,
      selected: [],
      sensorPintu: {
        name: "sensor-pintu",
        data: [
          {
            id: "sensor-Pintu-1",
            value: "1",
            title: "Ada sensor pintu",
            checked: false,
            titleBold: false,
          },
          {
            id: "sensor-Pintu-2",
            value: "2",
            title: "Tidak ada sensor pintu",
            checked: false,
            titleBold: false,
          },
        ]
      },
      statusPintu: {
        name: "status-pintu",
        data: [
          {
            id: "status-pintu-1",
            value: "1",
            title: "Pintu Terbuka",
            checked: false,
            titleBold: false,
          },
          {
            id: "status-pintu-2",
            value: "2",
            title: "Pintu Tertutup",
            checked: false,
            titleBold: false,
          }
        ]
      }
    }
  },
  computed: {
    ...mapGetters("filterGlobalModule", {
      filterItem: "getFilterItem"
    })
  },
  watch: {
    selected: {
      handler: function (v) {
        // console.log("sen", v)
        this.showStatus = v.includes("1");
      }
    }
  },
  methods: {
    selectedSensor(val) {
      let temp = this.filterItem
      temp.sensorPintu = val
      this.$store.commit("filterGlobalModule/setFilterItem", temp)
    },
    selectedStatus(val) {
      // console.log("sta", val)
      this.$emit("selected", val);
    },
  }
}
</script>

<style scoped>

</style>